export enum ParticipationStatusEnum
{
    PendingToSend,
    PendingResponse,
    InProgress,
    Response,
    Analyzed,
    Closed,
    Denied,
    SendingError
}